import { useCallback, useEffect, useState } from 'react';

export const useIsBrowserTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState<boolean>(true);

  const handleVisibilityChange = useCallback(() => {
    setIsTabVisible(document.visibilityState === 'visible');
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return isTabVisible;
};
